import { render, staticRenderFns } from "./Lydia.vue?vue&type=template&id=dcdca11c&scoped=true&"
import script from "./Lydia.vue?vue&type=script&lang=js&"
export * from "./Lydia.vue?vue&type=script&lang=js&"
import style0 from "./Lydia.vue?vue&type=style&index=0&id=dcdca11c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcdca11c",
  null
  
)

export default component.exports